import React from 'react';
import { clsx } from 'clsx';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { routeNames, routes } from 'routes';

import LogoWithText from 'assets/img/logo.png';
import Logo from 'assets/img/one.svg';

import styles from './styles.module.scss';
import { socials } from 'helpers/socials';
import { useGetAccountInfo } from '@multiversx/sdk-dapp/hooks';


export const Sidebar = () => {
  const location = useLocation();
  const { address: userAddress } = useGetAccountInfo();

  return (
    <div className={clsx(styles.sidebar, 'd-flex flex-column')}>
      <div className={clsx(styles.header, 'd-flex justify-content-center')}>
        <img className={styles.logoWithText} src={LogoWithText} alt='onedex logo' />
        {/* <img className={styles.logo} src={Logo} alt='onedex logo' /> */}
      </div>
      <div className={clsx(styles.menu, 'd-flex flex-column')}>
        {
          routes.map((route, index) => 
            !route.isSubMenu && !(!userAddress && route.path == routeNames.dashboard) &&
              <Link className={clsx(styles.menuItem, (location.pathname === route.path) && styles.active)} to={route.path} key={index}>
                <div className='d-flex justify-content-center' style={{ width: 24, position: 'absolute' }}>
                  <img style={{ width: '100%' }} src={location.pathname === route.path ? route.active_icon : route.icon} />
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {route.title}
                <div style={{ width: '100%', textAlign: 'end' }}>
                  { location.pathname === route.path ? '>' : '' }
                </div>
              </Link>
          )
        }
      </div>
      <div className='flex-grow-1' />
      <div className={clsx(styles.socials, 'd-flex justify-content-around')}>
        {
          socials.map((social, index) => 
            <a key={index} href={social.link} target='_blank' rel='noreferrer' className={styles.icon}>
              <span className={social.icon} />
            </a>
          )
        }
      </div>
    </div>
  );
};
